<template>
  <DragDialog
    title="提示"
    :width="600"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="cancel"
  >
    <div v-if="isExistReadOnly" class="tip-msg-box">
      <div class="content-box">
        <div class="icon-box">
          <i class="el-icon-warning icon"></i>
        </div>
        <div class="msg-box dialog-label">
          {{ getReadOnlyTipHeader() }}
          无法更改坐标系，若要更改，请使用最新版地形处理工具重新处理。
          <span @click="downloadFile" class="download-btn">点击下载</span>
        </div>
      </div>
      <div class="common-button-box">
        <el-button class="primary-btn" size="small" type="primary" @click="cancel">
          确定
        </el-button>
      </div>
    </div>
    <div class="tip-box" v-else>
      <div class="content-box">
        <!-- <div class="icon-box">
          <i class="el-icon-warning icon"></i>
        </div> -->
        <div class="msg-box dialog-label">
          {{ getTipHeader() }}
          更改坐标参考信息后，可能会导致其在场景中的位置发生变化，是否继续？
        </div>
      </div>
      <div class="collapse-box" @click="toggleDetailVisible">
        <icon-svg icon-class="ic-chakanxiangqing" size="16" class="icon" />
        <span class="dialog-label">查看详情</span>
        <i
          :class="`el-icon-caret-bottom collapse-icon ${
            isDetailVisible ? 'rotate' : ''
          }`"
        ></i>
      </div>
      <div class="scene-box" v-if="isDetailVisible">
        <div class="common-tree-box" v-if="isTreeVisible">
          <el-tree
          class="dialog-tree-primary"
            :data="treeData"
            :indent="20"
            default-expand-all
            :expand-on-click-node="false"
          />
        </div>
        <div v-else class="scene-list">
          <div
            v-for="(item, index) in sceneList"
            :key="index"
            class="item-box"
            @click="viewScene(item)"
          >
            {{
              `${sceneList.length > 1 ? `${index + 1}. ` : ""}${item.sceneName}`
            }}
          </div>
        </div>
      </div>
      <div class="common-button-box btn-group-primary">
        <el-button size="small" class="hollowOut-btn primary-ang-btn gr8" @click="cancel">取消</el-button>
        <el-button size="small" type="primary" class="primary-btn primary-ang-btn" @click="continueNext">
          继续
        </el-button>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import axios from "axios";
import DragDialog from "@/components/CustomDragDialog.vue";

export default {
  data() {
    return {
      isDetailVisible: false,
      isTreeVisible: false,
      treeData: [],
      sceneList: [],

      isExistReadOnly: false,
      readOnlyDataSets: [],
    };
  },
  props: {
    visible: Boolean,
    readOnlyInfo: Object,
    dataSetsIsQuoted: Array,
    continueSetCrs: Function,
    closeDialog: Function,
  },
  components: {
    DragDialog,
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initData();
      }
    },
  },
  methods: {
    initData() {
      let readOnlyInfo = this.readOnlyInfo;
      if (Object.keys(readOnlyInfo).length) {
        this.isExistReadOnly = readOnlyInfo.isExistReadOnly;
        this.readOnlyDataSets = readOnlyInfo.readOnlyDataSets;
        return;
      }

      let dataSets = this.dataSetsIsQuoted;
      if (dataSets.length > 1) {
        this.isTreeVisible = true;
        let treeData = [];
        dataSets.forEach((item) => {
          let children = item.refScenes.map((el) => {
            return { nodeId: el.sceneId, label: el.sceneName, children: [] };
          });
          let obj = {
            nodeId: item.dataSetId,
            label: item.dataSetName,
            children,
          };
          treeData.push(obj);
        });
        this.treeData = treeData;
      } else {
        let dataSetInfo = this.dataSetsIsQuoted[0];
        let sceneList = dataSetInfo.refScenes;
        this.sceneList = sceneList;
      }
    },
    getTipHeader() {
      if (!this.visible) return "";

      let headerString = "";
      if (this.dataSetsIsQuoted.length > 1) {
        headerString = `${this.dataSetsIsQuoted.length}个数据集被场景引用，`;
      } else {
        let dataSetInfo = this.dataSetsIsQuoted[0];
        headerString = `${dataSetInfo.dataSetName}已被场景引用，`;
      }
      return headerString;
    },
    getReadOnlyTipHeader() {
      if (!this.isExistReadOnly) return "";

      let headerString = "";
      if (this.readOnlyDataSets.length > 1) {
        headerString = `${this.readOnlyDataSets.length}个数据集已进行过投影变换，`;
      } else {
        let dataSetInfo = this.readOnlyDataSets[0];
        headerString = `${dataSetInfo.dataSetName}已进行过投影变换，`;
      }
      return headerString;
    },
    continueNext() {
      this.cancel();
      this.continueSetCrs();
    },
    toggleDetailVisible() {
      this.isDetailVisible = !this.isDetailVisible;
    },
    cancel() {
      this.isDetailVisible = false;
      this.isTreeVisible = false;
      this.treeData = [];
      this.sceneList = [];

      this.isExistReadOnly = false;
      this.readOnlyDataSets = [];

      this.closeDialog();
    },
    downloadFile() {
      // prettier-ignore
      const firstVersionUrl = "api/developercenter/Doc/DocItem/first/bydcid";
      const dcId = "3a0ba2a1-87ca-cff9-75e6-ff00057696de";
      let requestUrl = `${window.developerUrl}/${firstVersionUrl}?dcid=${dcId}`;
      axios.get(requestUrl).then((result) => {
        if (result.status === 200) {
          let response = result.data;
          if (response.isSuccess) {
            let data = response.data;
            let accessory = data.accessory;
            let downloadUrl = `${window.developerUrl}/api/developercenter/download/${accessory}`;
            window.open(downloadUrl);
          }
        }
      });
    },
    viewScene(sceneInfo) {
      let projId = this.$route.params.projId;
      let projName = this.$route.params.projName;
      projName = encodeURIComponent(projName);
      let dataType = this.$route.query.dataType;
      const routerUrl = this.$router.resolve({
        path: `../../sceneView/${projId}/${projName}`,
        query: {
          sceneId: sceneInfo.sceneId,
          dataType: dataType,
        },
      });

      window.open(routerUrl.href, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";
.tip-msg-box {

  .content-box {
    display: flex;

    .icon-box {
      color: #ec9d00;
      font-size: 18px;
      margin-right: 5px;
    }

    .msg-box {
      margin-left: 5px;
      word-break: break-all;
      overflow: hidden;
    }
  }

  .download-btn {
    color: var(--base-primary-bgColor);
    cursor: pointer;
  }

  // .common-button-box {
  //   margin-top: 10px;
  //   text-align: right;
  // }
}
.tip-box {
  .common-button-box{
    display: flex;
    justify-content: flex-end;
  }

  .content-box {
    display: flex;
    color: var(--page-tips-text-color);

    .icon-box {
      color: #ec9d00;
      font-size: 18px;
      margin-right: 5px;
    }

    .msg-box {
      word-break: break-all;
      overflow: hidden;
    }
  }

  .collapse-box {
    display: flex;
    align-items: center;
    margin: 10px 0px;
    user-select: none;

    .dialog-label{
      font-size: 14px;
    }

    .icon {
      margin-right: 5px;
      color: var(--icon-dark-color);
    }

    .collapse-icon {
      margin-left: 5px;
      cursor: pointer;
      color: var(--icon-dark-color);
    }

    .rotate {
      transform: rotate(-180deg);
    }
  }

  .scene-box {
    margin: 10px 0px;
    padding: 15px;
    max-height: 200px;
    overflow-y: auto;
    background-color: var(--dialog-queo-bgColor);
    border-radius: 4px;

    .scene-list {
      .item-box {
        margin: 5px 0px;
        font-size: 14px;
        color: var(--dialog-queo-text-color);

        &:hover {
          cursor: pointer;
          color: var(--base-primary-bgColor);
          text-decoration: underline;
        }
      }
    }
  }

  // .common-button-box {
  //   text-align: right;
  // }
}
</style>